<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.company.update")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineCompanyForm :APIbaseURL="APIbaseURL" :company="company" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineCompanyForm } from 'aveine-company';
import { Company } from 'aveine-toolbox';
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      company: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineCompanyForm
  },
  async created() {
    try {
      await Company.api().get(`companies/${this.$route.params.id}?lang=${this.$i18n.locale}`, {
          params: {
            include:
            'company-contact,' +
            'legal-entity-type,' +
            'address.country,address.spatial-information',
          }
        }
      );
      this.company = await Company.query().whereId(this.$route.params.id).withAllRecursive().first();
      this.dataLoaded = true;
    } catch (errors) {
      this.dataLoaded = true;
      errorHandler(errors, this)
    }
  },
}
</script>
